export const Shadows = {
    "shadow1": {
        data: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/1.svg"
    },
    "shadow2": {
        data: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/2.svg"
    },
    "shadow3": {
        data: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        image: "https://mobligo-bucket.s3.eu-central-1.amazonaws.com/3.svg"
    }
}